import { Link } from "wouter";
import { useI18n } from "../lib/i18n";
import type { PostOwnership } from "../lib/api";

export function ClosedPostNotice({ post }: { post: PostOwnership }) {
  const { t } = useI18n();
  if (!post.ownerClosed && !post.hidden && !["closed", "archived", "removed"].includes(post.status || "")) return null;
  return <div role="status" className="mb-4 rounded-xl border border-line bg-navy-50 px-4 py-3 text-sm text-navy">
    <strong>{t("post.owner.closedNotice")}</strong><p>{t("post.owner.existingContinue")}</p><Link href="/messages" className="mt-1 inline-block font-semibold underline">{t("nav.messages", "Messages")}</Link>
  </div>;
}
